import React from 'react';
import { Container, Box, Typography, CircularProgress, Alert } from '@mui/material';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { useMarkdownContent } from '../hooks/useMarkdownContent';

const PrivacyPolicy = () => {
  const { content, loading, error } = useMarkdownContent('privacy-policy.md');

  if (loading) {
    return (
      <Container>
        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <CircularProgress />
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container>
        <Alert severity="error" sx={{ mt: 4 }}>
          Failed to load Privacy Policy: {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 4, mb: 4 }}>
        <ReactMarkdown
          remarkPlugins={[remarkGfm]}
          components={{
            h1: ({ children }) => (
              <Typography variant="h3" component="h1" gutterBottom sx={{ mt: 4, mb: 2 }}>
                {children}
              </Typography>
            ),
            h2: ({ children }) => (
              <Typography variant="h5" component="h2" sx={{ mt: 3, mb: 2 }}>
                {children}
              </Typography>
            ),
            h3: ({ children }) => (
              <Typography variant="h6" component="h3" sx={{ mt: 2, mb: 1 }}>
                {children}
              </Typography>
            ),
            p: ({ children }) => (
              <Typography variant="body1" paragraph sx={{ mb: 2 }}>
                {children}
              </Typography>
            ),
            ul: ({ children }) => (
              <Box component="ul" sx={{ pl: 3, mb: 2 }}>
                {children}
              </Box>
            ),
            ol: ({ children }) => (
              <Box component="ol" sx={{ pl: 3, mb: 2 }}>
                {children}
              </Box>
            ),
            li: ({ children }) => (
              <Typography component="li" variant="body1" sx={{ mb: 0.5 }}>
                {children}
              </Typography>
            ),
            strong: ({ children }) => (
              <Typography component="span" sx={{ fontWeight: 'bold' }}>
                {children}
              </Typography>
            ),
            blockquote: ({ children }) => (
              <Box
                component="blockquote"
                sx={{
                  borderLeft: 4,
                  borderColor: 'primary.main',
                  pl: 2,
                  ml: 0,
                  fontStyle: 'italic',
                  backgroundColor: 'grey.50',
                  py: 1,
                  mb: 2,
                }}
              >
                {children}
              </Box>
            ),
          }}
        >
          {content}
        </ReactMarkdown>
      </Box>
    </Container>
  );
};

export default PrivacyPolicy;